import { all, takeLatest } from 'redux-saga/effects';
import { fetchShopData } from '../actions';
import fetchShopDataWorker from './worker.fetchShopData';

function* shopCouponCodesSaga() {
  yield all([takeLatest(fetchShopData, fetchShopDataWorker)]);
}

export default shopCouponCodesSaga;
